import React from 'react';
import { IconBtnCopy, IconBtnMypixel } from '../../img';
//import Dropdown from 'react-dropdown';

const InstallCard = ({
  copyWallScript
}) => {
  let profile = '';
  let state = '';
  let loading = false;
  let isClick = false;
  let isPixel = false;

  const startVerifyPixel = () => {

  };

  const onVerify = () => {

  };


  let _brandName = 'Widget';
  let _brandURL = 'https://pt.wisernotify.com';
  let script = '<script>!function () { if (window.t4hto3e) console.log("Widget pixel installed multiple time in this page"); else { window.t4hto3e = !0; var t = document, e = window, n = function () { var e = t.createElement("script"); e.type = "text/javascript", e.async = !0, e.src = "' + _brandURL + '/widget.js?t=" + Date.now(), document.body.appendChild(e) }; "complete" === t.readyState ? n() : window.attachEvent ? e.attachEvent("onload", n) : e.addEventListener("load", n, !1) } }();</script>';

  return (
    <div className="card card-install card-pixel ">
      <div className="card-inblock card-intro-body text-center">
        <a href="" className="pixel-link" target="_blank"><h4 className=" mb-10">Install Your Pixel</h4></a>
        <h6 className="pixel-info mb-20">Copy & paste this pixel code to every page of your site that you plan to display the notification & capture data.</h6>
        <figure className="highlight mb-20">
          <pre>
            &lt;!-- {_brandName} BEGIN --&gt;
            <br />
            <span onClick={() => copyWallScript(script)}>{script}</span>
            <br />
            &lt;!-- {_brandName} END --&gt;
          </pre>
          <div className="copy-script-upbg" id="copy-pixel">
            <div className="copy-script-content" onClick={() => copyWallScript(script)}>
              <img className="" src={IconBtnCopy} alt="notifly" />
              <span>Press here to copy the code</span>
            </div>
          </div>
        </figure>
        <div className="verify-check-block">
          <div className="verify-check-box">
            {
              profile && profile.vstp && profile.vstp.plx && profile.vstp.plx.st == false ?
                state.verifyTime == 50 ?
                  <button className="nf-btn  nf-btn-default nf-btn-icon nf-btn-min15x" onClick={() => startVerifyPixel()}>
                    <img className="" src={IconBtnMypixel} alt="notifly" />  Verify Pixel
                  </button>
                  :
                  <div className="loader-pixel nf-btn-min15x">
                    <div className="spinner-pixel"></div>
                  </div>
                :
                <button className="nf-btn  nf-btn-default nf-btn-icon nf-btn-min15x" onClick={() => onVerify()}>
                  <img className="" src={IconBtnMypixel} alt="notifly" />  Verify Pixel
                </button>
            }
          </div>
          <div className="verify-text">
            {
              loading === false &&
              <div>
                {
                  isClick == false &&
                  isPixel == 'found' &&
                  <p>Your pixel has been detected successfully. <Link to="notification?ds=type">Create Notification </Link></p>
                }
                {
                  isClick == false &&
                  isPixel == 'notFound' &&
                  <p className='pixel-blink'>Your pixel has not been detected yet!</p>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallCard;




// WEBPACK FOOTER //
// ./src/components/Pixel/InstallCard.js